
<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Sign Up</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>User Registration</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="dashboard-area pt-100">
  <div class="container">
      <div class="create-information">
          <form [formGroup]="sform" (ngSubmit)="saveData()">
              <h3>{{title}}</h3>

              <div class="row">

                   <div class="row">
                     <!-- First Name -->
                     <div class="col-lg-6">
                      <div class="form-group">
                          <label for="firstname">Firstname</label>
                          <input type="text" class="form-control"
                          id="firstname" placeholder="firstname"
                          formControlName="firstname"
                          [ngClass]="{'is-invalid': displayMessage.firstname }">
                          <span class="invalid-feedback">
                            {{displayMessage.firstname}}
                          </span>
                      </div>
                    </div>

                    <!-- Lastname -->
                    <div class="col-lg-6">
                      <div class="form-group">
                          <label for="lastname">Lastname</label>
                          <input type="text" class="form-control"
                          id="lastname" placeholder="lastname"
                          formControlName="lastname"
                          [ngClass]="{'is-invalid': displayMessage.lastname }">
                          <span class="invalid-feedback">
                            {{displayMessage.lastname}}
                          </span>
                      </div>
                    </div>

                   </div>

                   <div class="row">
                    <!-- Contact -->
                     <div class="col-lg-6">
                       <div class="form-group">
                         <label for="contact">Contact:</label>
                         <input type="text" class="form-control"
                           id="contact" placeholder="08024714586"
                           formControlName="contact"
                           [ngClass]="{'is-invalid': displayMessage.contact }">
                           <span class="invalid-feedback">
                             {{displayMessage.contact}}
                           </span>
                       </div>
                     </div>

                   <!-- email -->
                     <div class="col-lg-6">
                       <div class="form-group">
                         <label for="email">Email:</label>
                           <input type="email" class="form-control"
                           id="email" placeholder="example@yahoo.com"
                           formControlName="email"
                           [ngClass]="{'is-invalid': displayMessage.email }">
                           <span class="invalid-feedback">
                             {{displayMessage.email}}
                           </span>
                       </div>
                     </div>
                  </div>

                   <div class="row">
                     <!-- Address-->
                     <div class="col-lg-12">
                      <div class="form-group">
                        <label for="address">Address:</label>
                          <textarea type="text" class="form-control" rows="5"
                          id="address" placeholder="Residential/Business address"
                          formControlName="address"
                          [ngClass]="{'is-invalid': displayMessage.address }">
                          </textarea>
                          <span class="invalid-feedback">
                            {{displayMessage.address}}
                          </span>
                      </div>
                    </div>

                   </div>

                  <div class="row">
                      <!-- Username -->
                      <div class="col-lg-6">
                        <div class="form-group">
                            <label>Username:</label>
                            <input type="text" class="form-control"
                            id="username" placeholder="username"
                            formControlName="username"
                            [ngClass]="{'is-invalid': displayMessage.username }">
                            <span class="invalid-feedback">
                              {{displayMessage.username}}
                            </span>
                        </div>
                      </div>

                      <!-- Password -->
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="address">Password:</label>
                            <input type="password" class="form-control"
                            id="password"
                            formControlName="password"
                            [ngClass]="{'is-invalid': displayMessage.password }">
                            <span class="invalid-feedback">
                              {{displayMessage.password}}
                            </span>
                        </div>
                      </div>
                  </div>

              </div>

              <div class="text-left">
                <button type="submit" class="btn create-ac-btn"
                  [title]="sform.valid"
                  [disabled]="!sform.valid">
                  Save</button>
              </div>

          </form>
      </div>

  </div>
</div>
